'use strict';

export const commonVar = {
    paths : ['/unsubscribe', '/softwareDownload', '/errors', '/termsOfUse']
};

export const ZENDESK_ARTICLES = {
    FACILITY_CONNECT_TV_TUNER_PAGE_OVERVIEW: "https://lifefitness9512.zendesk.com/hc/en-us/articles/25683984086295-Facility-Connect-TV-Tuner-Page-Overview",
    FACILITY_CONNECT_IPTV_PAGE_OVERVIEW: "https://lifefitness9512.zendesk.com/hc/en-us/articles/25684002878103-Facility-Connect-IPTV-Page-Overview",
    FACILITY_CONNECT_WEB_SHORTCUTS_PAGE_OVERVIEW: "https://lifefitness9512.zendesk.com/hc/en-us/articles/25760949419415-Facility-Connect-Web-Shortcuts-Page-Overview",
    FACILITY_CONNECT_APPS_PAGE_OVERVIEW: "https://lifefitness9512.zendesk.com/hc/en-us/articles/25760083304087-Facility-Connect-Apps-Page-Overview"
};